import React from 'react';
import { PricingOffer } from '../../../types/product';

interface PricingOfferSectionProps {
  value: PricingOffer;
  onChange: (value: PricingOffer) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';
const FIELD_GROUP = 'mb-5 last:mb-0';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const INPUT =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const TEXTAREA =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] [font-family:inherit] resize-y transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const HELP_TEXT = 'm-0 mt-1.5 text-[12px] text-[#666]';

export const PricingOfferSection: React.FC<PricingOfferSectionProps> = ({
  value,
  onChange
}) => {
  const handleChange = (field: keyof PricingOffer, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>料金・オファー情報</h3>
      <p className={SECTION_DESCRIPTION}>
        価格設定とオファー内容を入力してください
      </p>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>メインCTA</label>
        <input
          className={INPUT}
          type="text"
          value={value.main_cta || ''}
          onChange={(e) => handleChange('main_cta', e.target.value)}
          placeholder="例: 無料トライアル"
          maxLength={255}
        />
        <p className={HELP_TEXT}>主要な行動喚起メッセージ</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>価格の可視性</label>
        <input
          className={INPUT}
          type="text"
          value={value.price_visibility || ''}
          onChange={(e) => handleChange('price_visibility', e.target.value)}
          placeholder="例: 公開"
          maxLength={100}
        />
        <p className={HELP_TEXT}>価格情報の公開度合い</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>価格詳細</label>
        <textarea
          className={TEXTAREA}
          value={value.price_details || ''}
          onChange={(e) => handleChange('price_details', e.target.value)}
          placeholder="例: 月額3,280円（税込）"
          rows={3}
        />
        <p className={HELP_TEXT}>具体的な価格情報</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>オファー・キャンペーン</label>
        <textarea
          className={TEXTAREA}
          value={value.offers_campaigns || ''}
          onChange={(e) => handleChange('offers_campaigns', e.target.value)}
          placeholder="例: 初月無料キャンペーン実施中"
          rows={3}
        />
        <p className={HELP_TEXT}>現在実施中のキャンペーンや特典</p>
      </div>
    </div>
  );
};
